import { redirect } from 'react-router-dom';
import { ME_QUERY } from '../gql/user';
import { getClient } from '../lib/apollo';
import { DASHBOARD } from '../../customers/src/routes';

export const guestLoader = async () => {
  try {
    const client = getClient();
    const { data } = await client.query({
      query: ME_QUERY,
      fetchPolicy: 'cache-first',
      errorPolicy: 'ignore',
    });

    if (data?.me) {
      throw redirect(DASHBOARD);
    }

    return null;
  } catch (error) {
    if (error && typeof error === 'object' && 'status' in error) {
      throw error;
    }

    return null;
  }
};
